module.exports = __webpack_public_path__ + "img/parterNew.7452b34f.png";